<template>
  <div class="login">
    <div class="pdd-app-skeleton">
      <div class="pdd-app-skeleton-body-wrapper">
        <div class="pdd-app-skeleton-body">
          <main class="pdd-app-skeleton-content">
            <div class="login-center">

              <section style="min-width: 800px;">
                <div class="login-header">
                  <div class="login-header-logo">
                    <a href="https://bigdataonk8s.com"><img src="/static/images/logo.png" alt=""></a>
                  </div>
                  <span class="login-header-text">专注BigData On K8s实战课程</span>
                </div>
              </section>

              <section class="login-content"><img
                src="/static/images/login/background.jpg"
                class="login-img">
                <div class="login-info-section">
                  <div class="info-part">

                    <div class="login-tab" style="margin-bottom: 2px;">
                      <div class="tab-operate">
                        <div class="tab-item" style="font-size: 24px;">欢迎登录</div>
                      </div>
                      <el-button type="primary" style="width: 92px; height: 32px; line-height: 8px" @click="gotoRegister">用户注册</el-button>
                    </div>

                    <div class="password-section">
                      <section>
                        <div>
                          <div class="info-danger-warn">
                            <div class="info-danger-container">

                            </div>
                          </div>

                          <div class="info-content">

                            <div v-if="!loginType">
                              <div class="info-content-item">
                                <el-input
                                  placeholder="请输入用户名/手机号"
                                  prefix-icon="el-icon-user-solid"
                                  v-model="loginPhone">
                                </el-input>
                              </div>

                              <div class="info-content-item">
                                <el-input
                                  placeholder="请输入密码"
                                  prefix-icon="fas fa-lock"
                                  type="password"
                                  v-model="password">
                                </el-input>
                              </div>
                            </div>
                            <div v-else>
                              <div class="info-content-item">
                                <el-input
                                  placeholder="请输入手机号"
                                  oninput="value=value.replace(/[^\d]/g,'')"
                                  maxlength="11"
                                  prefix-icon="fas fa-mobile-alt"
                                  v-model="loginPhone">
                                </el-input>
                              </div>

                              <div class="info-content-item">
                              <span style="width: 50%">
                                <el-input
                                  placeholder="请输入短信验证码"
                                  prefix-icon="fas fa-envelope"
                                  type="text"
                                  maxlength="6"
                                  style="width: 100%;"
                                  v-model="code">
                                </el-input>
                              </span>
                                <span style="width: 48%">
                                <el-button type="danger"
                                           :disabled="!rightPhone"
                                           style="width: 100%; height: 40px;"
                                           @click.prevent="getCode">
                                  <!--发送验证码-->
                                  {{ computeTime ? `已发送(${computeTime})s` : '获取验证码'}}
                                </el-button>
                              </span>
                              </div>
                            </div>

                            <el-button type="danger" @click="loginType ? messageLogin() : passwordLogin()" style="width: 100%; height: 40px">登录</el-button>
                            <div style="margin-top: 8px; font-size: 14px; text-align: right">
                              <el-link v-if="!loginType" type="info" :underline="false" @click="changeLoginType">验证码登录</el-link>
                              <el-link v-else type="info" :underline="false" @click="changeLoginType">密码登录</el-link>
                              <el-link type="info" :underline="false" @click="gotoResetPassword">忘记密码</el-link>
                            </div>

                          </div>
                        </div>
                      </section>
                    </div>

                  </div>
                </div>

              </section>

              <section class="login-footer">
                <div class="login-copyright">Copyright &copy;{{currentYear}} bigdataonk8s.com 版权所有
                  <div class="login-copyright-police">
                    <img src="/static/images/PSO.png" class="police-img">
                    <a class="login-copyright" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44040202001433">
                      <span style="cursor: pointer;">粤公网安备
                                            44040202001433号</span>
                    </a>
                    <div class="BeastCoreDivider__vertical__3vxv8__2-33-1"></div>
                    <a class="login-copyright" target="_blank" href="http://beian.miit.gov.cn">
                      <span style="cursor: pointer;">粤ICP备2023032905号-1</span>
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import { setLoginPhone, setUUID, getPhone } from '@/common/auth'
import {
  // getHello,
  reqLogin,
  reqSendCode,
  reqCheckCodeLogin
} from '@/api'

export default {
  name: 'Login',
  data() {
    return {
      loginType: 0, // 登录方式0-密码登录 1-验证码登录
      loginPhone: '',
      code: '',
      computeTime: 0,
      account: '',
      password: '',
      userType: 1
    }
  },

  mounted() {
    this.loginPhone = sessionStorage.getItem('loginPhone') ? sessionStorage.getItem('loginPhone') : getPhone()
    this.account = this.loginPhone
  },

  methods: {

    // 获取短信验证码
    async getCode () {
      // computeTime等于0的时候才执行
      if (!this.computeTime) {
        this.computeTime = 60
        this.intervalId = setInterval(() => {
          this.computeTime--
          if (this.computeTime <= 0) {
            clearInterval(this.intervalId)
          }
        }, 1000)

        // 发送ajax请求
        const result = await reqSendCode(this.loginPhone)
        if (result.code === 1) {
          this.$alert(`${ result.message }`, '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          if (this.computeTime) {
            this.computeTime = 0
            clearInterval(this.intervalId)
          }
        }

      }
    },

    // 更换登录方式响应事件处理
    changeLoginType () {
      this.loginType = (this.loginType - 1) * -1
    },

    // 跳转到注册登录页面
    gotoRegister () {
      this.$router.push('/register')
    },

    // 跳转到忘记密码重置页面
    gotoResetPassword () {
      this.$router.push('/resetPassword')
    },

    // 验证码登录
    async messageLogin () {
      if (!this.rightPhone) {
        await this.$alert('手机号码不正确', '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      } else if (!/^\d{6}$/.test(this.code)) {
        await this.$alert('短信验证码不正确', '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      }

      // 每次登录都重置uuid
      setUUID()

      // 发送ajax请求
      const result = await reqCheckCodeLogin(this.loginPhone, this.code, this.loginType)
      if (result.code === 1) {
        await this.$alert(`${ result.message }`, '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })

        if (this.computeTime) {
          this.computeTime = 0
          clearInterval(this.intervalId)
        }
      } else {

        const phone = this.loginPhone.trim()
        setLoginPhone(phone) // 将loginPhone保存到cookie
        await this.$store.dispatch('setPhone', {phone})
        sessionStorage.setItem('loginPhone', phone)

        clearInterval(this.intervalId)

        this.$message({
          message: '登录成功',
          type: 'success'
        })

        if (this.loginSource === 1)
          await this.$router.push('/')
        else {
          await this.$router.push({
            path: '/course',
            query: {no: this.loginSource%1000}
          })
        }
      }

    },

    // 密码登录按钮事件处理
    async passwordLogin () {

      if (!this.rightPhone || !this.rightPassword) {
        await this.$alert('请输入正确的登录信息', '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      }

      // 每次登录都重置uuid
      setUUID()
      const result = await reqLogin(this.loginPhone.trim(), this.password.trim(), this.userType)
      if (result.code === 1) {
        await this.$alert(`${ result.message }`, '错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })

      } else {
        const phone = this.loginPhone.trim()
        setLoginPhone(phone) // 将loginPhone保存到cookie
        await this.$store.dispatch('setPhone', {phone})
        sessionStorage.setItem('loginPhone', phone)

        this.$message({
          message: '登录成功',
          type: 'success'
        })

        // console.log(this.loginSource)
        if (this.loginSource === 1)
          await this.$router.push('/')
        else {
          await this.$router.push({
            path: '/course',
            query: {no: this.loginSource%1000}
          })
        }
      }
    }
  },

  computed: {
    ...mapState(['loginSource']),

    rightAccount () {
      return (/^8\d{7}$/.test(this.account)) || (/^1\d{10}$/.test(this.account))
    },

    rightPassword () {
      return (this.password && this.password.trim().length >= 8)
    },

    rightPhone () {
      // return /^1\d{10}$/.test(this.loginPhone)
      return /^1[2|3|4|5|6|7|8|9][0-9]{9}$/.test(this.loginPhone)
    },

    currentYear: function () {
      return new Date().getFullYear()
    }

  }
}
</script>

<style scoped>

  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    -webkit-font-feature-settings: "tnum";
    -moz-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    font-variant: tabular-nums;
    line-height: 1.5;
  }

  .info-content {
    width: 350px;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
  }

  .info-content-item {
    margin-bottom: 24px;
  }

  img {
    vertical-align: middle;
    border-style: none;
  }

  *,
  :after,
  :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .pdd-app-skeleton {
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    min-height: 100vh;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .pdd-app-skeleton-body {
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 1 1;
    -moz-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
  }

  .pdd-app-skeleton-content {
    -webkit-flex: 1 1;
    -moz-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
  }

  .pdd-app-skeleton,
  .pdd-app-skeleton-body {
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  @media (min-width: 768px) {
    .pdd-app-skeleton-body-wrapper {
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex: 1 1;
      -moz-box-flex: 1;
      -ms-flex: 1 1;
      flex: 1 1;
      -webkit-justify-content: center;
      -moz-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }

    .pdd-app-skeleton-body {
      -webkit-flex-direction: row;
      -moz-box-orient: horizontal;
      -moz-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-flex-basis: 1280px;
      -ms-flex-preferred-size: 1280px;
      flex-basis: 1280px;
      -webkit-flex-grow: 0;
      -moz-box-flex: 0;
      -ms-flex-positive: 0;
      flex-grow: 0;
    }

    .pdd-app-skeleton-content {
      -webkit-flex: 1 1;
      -moz-box-flex: 1;
      -ms-flex: 1 1;
      flex: 1 1;
    }

  }

  .login-center {
    background: #ffffff;
  }

  .login-center .login-tab {
    font-size: 14px;
    color: #333333;
    text-align: justify;
    line-height: 28px;
    height: 28px;
    padding: 0 36px;
  }

  .login-center .login-tab .tab-operate {
    display: inline-block;
    cursor: pointer;
  }

  .login-center .login-tab .tab-operate .tab-item {
    display: inline-block;
    text-align: center;
    margin-right: 20px;
  }

  .login-center .login-tab .tab-operate .last-item {
    position: relative;
  }

  .login-center .login-tab .tab-operate .last-item::before {
    content: "";
    position: absolute;
    width: 1px;
    height: 14px;
    top: 7px;
    left: -11px;
    background-color: #DBDBDB;
  }

  .login-center .login-tab button {
    float: right;
  }

  .login-center .login-content {
    position: relative;
    height: 576px;
    width: 100%;
    min-width: 1920px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .login-center .login-content .login-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
  }

  .login-center .login-content .login-info-section {
    position: absolute;
    width: 420px;
    top: 67px;
    right: 400px;
  }

  .login-center .login-content .login-info-section .info-part {
    position: relative;
    width: 420px;
    height: 356px;
    padding: 30px 0 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: #ffffff;
    -moz-border-radius: 6px 6px 0px 0px;
    border-radius: 6px 6px 0px 0px;
  }

  .login-center .login-content .login-info-section .info-footer-btn {
    width: 420px;
    height: 44px;
    background: #fafafa;
    -moz-border-radius: 0px 0px 6px 6px;
    border-radius: 0px 0px 6px 6px;
    position: relative;
    font-size: 14px;
    color: #2266aa;
    line-height: 44px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
  }

  .login-center .login-content .login-info-section .info-footer-btn:after {
    clear: both;
    content: ' ';
    display: block;
    visibility: hidden;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-small-division {
    width: 2px;
    height: 24px;
    border: 1px solid #eaeaea;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -1px;
    margin-top: -12px;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-item {
    width: 50%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    float: left;
    padding: 12px 36px;
    height: 100%;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-item .info-footer-btn-item-content1 {
    cursor: default;
    line-height: 20px;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-item .info-footer-btn-item-content1:hover .info-footer-btn-app-down {
    display: block;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-item-content2 {
    cursor: pointer;
    line-height: 20px;
    position: relative;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-item-content2.new-active::after {
    content: "NEW";
    position: absolute;
    background: #ff5454;
    -moz-border-radius: 10px;
    border-radius: 10px;
    color: white;
    font-size: 12px;
    padding: 0 4px;
    top: -10px;
    margin-left: -4px;
    line-height: 16px;
    font-weight: 400;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-app-down {
    display: none;
    width: 129px;
    height: 155px;
    background: white;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 6px;
    position: absolute;
    bottom: 44px;
    left: 50%;
    z-index: 888;
    margin-left: -65px;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-app-down-arrow {
    position: absolute;
    left: 50%;
    bottom: -22px;
    margin-left: -12px;
    overflow: hidden;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px;
    background: transparent;
    border-color: #ffffff transparent transparent;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-app-down-img {
    width: 117px;
    height: 117px;
  }

  .login-center .login-content .login-info-section .info-footer-btn .info-footer-btn-app-down-text {
    padding-top: 4px;
    line-height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #333333;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }

  body {
    overflow-x: hidden;
  }

  .login-footer {
    text-align: center;
    height: 168px;
    padding-top: 35px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .login-footer .footer-tab {
    margin-bottom: 20px;
  }

  .login-footer .footer-tab .link-text {
    display: inline-block;
    height: 16px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    line-height: 16px;
    cursor: pointer;
  }

  .login-footer .footer-tab .link-text:hover {
    text-decoration: underline;
  }

  .login-footer .footer-tab .link-text:last-child {
    border-right: none;
  }

  .login-footer .login-copyright {
    font-size: 12px;
    color: #999;
    padding-bottom: 15px;
    line-height: 1.5;
  }

  .login-footer .login-copyright .login-copyright-police {
    margin-top: 6px;
  }

  .login-footer .login-copyright .login-copyright-police .police-img {
    height: 12px;
    width: 12px;
    margin-right: 3px;
    position: relative;
    top: -1px;
  }

  .BeastCoreDivider__vertical__3vxv8__2-33-1 {
    border-right: 1px solid #ebebeb;
    position: relative;
    margin: 0 8px;
    top: -0.06em;
    display: inline-block;
    vertical-align: middle;
    height: 0.9em;
  }

  .login-header {
    height: 96px;
    line-height: 96px;
    width: 100%;
    position: relative;
  }

  .login-header .login-header-text {
    vertical-align: bottom;
    display: inline-block;
    line-height: 78px;
    font-size: 20px;
    /*font-family: PingFangSC-Medium;*/
    font-family: Arial, sans-serif;
    font-weight: 500;
    color: #333;
  }

  /*.login-header img {*/
  /*  display: inline-block;*/
  /*  width: 130px;*/
  /*  height: 57px;*/
  /*}*/

  .login-header img {
    display: inline-block;
    width: 103px;
    height: 70px;
  }

  .login-header .login-header-logo {
    margin-left: 402px;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue